/**
 * Component: Delivery Dates
 * ------------------------------------------------------------------------------
 * Returns product delivery date depending on type and order cut off time.
 *
 * @namespace deliveryDates
 */

import log from 'salvo-lite/log'

import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range'
import momentBusinessDays from 'moment-business-days'

class DeliveryDates {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            beforeCutOffDays: window.theme.deliveryDays.lifestyleDeliveryBeforeCutOff,
            afterCutOffDays: window.theme.deliveryDays.lifestyleDeliveryAfterCutOff,
            ...JSON.parse(elem.getAttribute('data-delivery-dates') || '{}')
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const {beforeCutOffDays, afterCutOffDays} = this._data

        this._setDefaults()

        if (this._isBeforeCutOff()) {
            return this._renderDeliveryDate(beforeCutOffDays)
        } else {
            return this._renderDeliveryDate(afterCutOffDays)
        }
    }

    _setDefaults () {
        /**
         * Declare global moment local time.
         */
        moment.updateLocale('en', {
            relativeTime: {
                future: '%s'
            },
            workingWeekdays: [1, 2, 3, 4, 5],
            holidays: this._bankHolidays(),
            holidayFormat: 'DD-MM-YYYY'
        })

        moment.updateLocale('de', {
            relativeTime: {
                future: '%s'
            },
            workingWeekdays: [1, 2, 3, 4, 5],
            holidays: this._bankHolidays(),
            holidayFormat: 'DD-MM-YYYY'
        })

        moment.updateLocale('it', {
            relativeTime: {
                future: '%s'
            },
            workingWeekdays: [1, 2, 3, 4, 5],
            holidays: this._bankHolidays(),
            holidayFormat: 'DD-MM-YYYY'
        })

        /**
         * Declare timezone and locales.
         */
        this._timezone = 'Europe/London'
        if (window.theme.store.id === 'de_store') {
            this._timezone = 'Europe/Berlin'
            moment.locale('de')
        } else if (window.theme.store.id === 'it_store') {
            this._timezone = 'Europe/Rome'
            moment.locale('it')
        } else if (window.theme.store.id === 'es_store') {
            this._timezone = 'Europe/Madrid'
            moment.locale('es')
        } else if (window.theme.store.id === 'fr_store') {
            this._timezone = 'Europe/Paris'
            moment.locale('fr')
        } else {
            momentBusinessDays.locale('en')
        }

        /**
         * Format cut off time.
         */

        const customCutOffTime = document.querySelector('.expected-delivery__message').dataset.customCutoffTime

        if (customCutOffTime) {
            this._cutOffTime = customCutOffTime.split(':')
        } else {
            this._cutOffTime = window.theme.deliveryDays.deliveryCuttOff.split(':')
        }

        this._hours = this._cutOffTime[0]
        this._minutes = this._cutOffTime[1]

        /**
         * Date Variables.
         */
        this._dateFormat = 'YYYYMMDD.HHmmss'
        this._cutOffDate = momentBusinessDays
            .tz(this._timezone)
            .hour(this._hours)
            .minutes(this._minutes)
            .seconds(0)
        this._currentTime = momentBusinessDays.tz(this._timezone).format(this._dateFormat)
    }

    /**
     * Returns bank holiday array.
     */
    _bankHolidays () {
        const bankHolidayDates = []

        const presetHolidayArray = window.theme.deliveryDays.excludeBankHolidays.split(',')
        presetHolidayArray.forEach((item) => {
            bankHolidayDates.push(item)
        })

        return bankHolidayDates
    }

    /**
     * Check cut off time.
     */
    _isBeforeCutOff () {
        return this._currentTime <= this._cutOffDate.format(this._dateFormat)
    }

    /**
     * Render expected delivery dates
     */
    _renderDeliveryDate (deliveryPeriod) {
        const currentDate = moment(new Date()).format('DD-MM-YYYY')
        const deliveryDate = momentBusinessDays(currentDate, 'DD-MM-YYYY').businessAdd(deliveryPeriod)._d

        this._elem.textContent = moment(deliveryDate).format('dddd Do MMMM').replace('º', '')
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //   init,
    // })
}

export default DeliveryDates



// WEBPACK FOOTER //
// ./src/resources/scripts/components/DeliveryDates.js